'use strict'

interface Window {
    NiceSelect: any;
    ImageCompare: any;
}

document.addEventListener("DOMContentLoaded", function () {
    const baseSelect = document.getElementById("js-form-box-category");

    if (baseSelect) {
        var options = {placeholder: 'select'};
        window.NiceSelect.bind(baseSelect);
    }

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="contact-tooltip"]');

    if (tooltipTriggerList.length > 0) {
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
    }

    // Unikátní selektor pro tooltipy
    const tooltipTriggers = document.querySelectorAll<HTMLElement>('[data-bs-toggle="tooltip"]');
    let activeTooltipInstance: bootstrap.Tooltip | null = null; // Aktuálně otevřený tooltip
    let activeTooltipTrigger: HTMLElement | null = null;  // Trigger aktuálního tooltipu
    let closingTimeout: NodeJS.Timeout | null = null; // Timeout pro zavírání

    tooltipTriggers.forEach(trigger => {
        const tooltipInstance = new bootstrap.Tooltip(trigger, {
            trigger: 'manual', // Ruční ovládání zobrazování
            customClass: trigger.getAttribute('data-bs-custom-class') || '', // Přiřazení vlastní třídy
        });

        trigger.addEventListener('mouseenter', () => {
            // Pokud existuje timeout na zavření, zrušíme ho
            if (closingTimeout) {
                clearTimeout(closingTimeout);
                closingTimeout = null;
            }

            // Pokud existuje aktivní tooltip a není to tento trigger, zavřeme ho
            if (activeTooltipInstance && activeTooltipTrigger !== trigger) {
                activeTooltipInstance.hide();
            }

            // Otevřeme nový tooltip
            tooltipInstance.show();
            activeTooltipInstance = tooltipInstance;
            activeTooltipTrigger = trigger;
        });

        trigger.addEventListener('mouseleave', () => {
            // Nastavíme timeout pro zavření tooltipu
            closingTimeout = setTimeout(() => {
                const tooltipElement = document.querySelector(`.tooltip[data-popper-placement]`);
                if (
                    !trigger.matches(':hover') && // Myš není nad triggerem
                    !(tooltipElement && tooltipElement.matches(':hover')) // Myš není nad tooltipem
                ) {
                    tooltipInstance.hide();
                    activeTooltipInstance = null;
                    activeTooltipTrigger = null;
                }
            }, 200); // Delší prodleva pro lepší UX
        });
    });

    // Zavření tooltipu při kliknutí mimo triggery a tooltipy
    document.addEventListener('click', (event) => {
		if (!(event.target instanceof HTMLElement)) return;
        const tooltipElement = document.querySelector(`.tooltip[data-popper-placement]`);
        if (
            activeTooltipTrigger &&
            !event.target.closest('[data-bs-toggle="tooltip"]') && // Klik není na trigger
            !(tooltipElement && tooltipElement.contains(event.target)) // Klik není na tooltip
        ) {
            if (activeTooltipInstance) {
                activeTooltipInstance.hide();
                activeTooltipInstance = null;
                activeTooltipTrigger = null;
            }
        }
    });

    Aos.init();

    const viewers = document.querySelectorAll(".js-compare-item");

    if (viewers.length > 0) {
        viewers.forEach((element) => {
            const options = {
                controlColor: "#FFFFFF",
                controlShadow: false,
                addCircle: true,
                addCircleBlur: false,
                startingPoint: 50,
                hoverStart: true,
                smoothing: true,
                smoothingAmount: 150,
            }
    
            setTimeout(() => {
                new window.ImageCompare(element, options).mount();
            }, 0);
        });
    }
});